module.exports = __webpack_public_path__ + "static/media/Image_logo_white.8aa176e2.png";